import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import GridContainer from "../../material/components/Grid/GridContainer";
import GridItem from "../../material/components/Grid/GridItem";
import Card from "../../material/components/Card/Card";
import CardHeader from "../../material/components/Card/CardHeader";
import CardBody from "../../material/components/Card/CardBody";

import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

let customStyles = {
  ...styles,
  customTitle: {
    color: "#fff"
  }
};

const useStyles = makeStyles(customStyles);

function Home(props) {
  const classes = useStyles();

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="success">
            <Typography
              className={classes.cardTitle + " " + classes.customTitle}
              variant="h6"
            >
              Welcome to ACC
            </Typography>
          </CardHeader>
          <CardBody>
            <Typography gutterBottom>
              You may navigate to any section of the ACC Chapter Application by
              using the menu on the left
            </Typography>
            <Typography>The ACC has provided functionality for</Typography>
            <ul>
              <li>Chapter Financial Reporting</li>
              <li>Chapter Budgeting</li>
              <li>Reports and Data</li>
            </ul>
            <Typography>
              Help - At any time you may Click on the ? in each section of
              additional help
            </Typography>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

export default Home;
